import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaEye } from "react-icons/fa";

const UserTableInit = ({ setActiveTab, setSelected }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    axios
      .get(`${apiUrl}/user`)
      .then((res) => {
        setLoading(false);
        setData(res.data);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  const filteredData = Array.isArray(data)
    ? data.filter((item) => {
        const text = `${item?.firstName ?? ""} ${item?.lastName ?? ""} ${item?.email ?? ""}`;
        return (
          item?.id?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
          text.toLowerCase().includes(searchTerm.toLowerCase())
        );
      })
    : [];

    console.log(filteredData)
  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const selectUser = (idNo) => {
    const selected = data.filter((item) => item.id === idNo);
    setSelected(selected[0]);
    setActiveTab(2); // Select the first profile
  };

  return (
    <div className="w-full p-2 flex flex-col gap-2 overflow-auto">
      <div>
        <h1 className="text-xl text-center">List of users</h1>
      </div>

      {loading ? (
        "Fetching data"
      ) : data.length > 0 ? (
        <div className=" p-4">
          <div className="mb-4 flex flex-col sm:flex-row gap-4 items-start sm:items-center">
            <div className="w-full sm:flex-1 sm:pr-4 sm:max-w-md">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search users..."
                  value={searchTerm}
                  onChange={handleSearch}
                  className="w-full pl-12 pr-4 py-3 rounded-full shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent text-gray-700 font-medium border border-gray-300 bg-white transition-all duration-200 hover:shadow-xl"
                />
                <div className="absolute top-1/2 left-4 transform -translate-y-1/2 inline-flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5 text-gray-400"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="10" cy="10" r="7" />
                    <line x1="21" y1="21" x2="15" y2="15" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div className="overflow-x-auto w-full rounded-lg shadow-lg">
            <table className="min-w-full bg-white table-auto w-full">
              <thead>
                <tr className="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
                  <th className="px-6 py-3 border-b border-gray-200 font-semibold text-left">
                    Ref No.
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 font-semibold text-left">
                    Full Name
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 font-semibold text-left">
                    Mobile
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 font-semibold text-left">
                    Role
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 font-semibold text-left">
                    Status
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 font-semibold text-left">
                    Status
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 font-semibold text-left">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item) => (
                  <tr
                    key={item.id}
                    className="border-b border-gray-200 hover:bg-gray-100"
                  >
                    <td className="px-6 py-4 whitespace-nowrap text-gray-700">
                      {item.id}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-gray-700">
                      {item.firstName + " " + item.lastName}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-gray-700">
                      {item.mobile}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-gray-700">
                      {item?.LoginDetail?.UserRole?.roleName ?? "-"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-gray-700">
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                        item?.LoginDetail?.status
                          ? 'bg-green-100 text-green-800'
                          : 'bg-red-100 text-red-800'
                      }`}>
                        {item?.LoginDetail?.status ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-gray-700">
                      <button
                        className=""
                        onClick={() => selectUser(item.id)}
                      >
                        <FaEye fontSize={28} color="green" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        "User not found"
      )}
    </div>
  );
};

export default UserTableInit;
